import { type TomBadge } from '@/ui/primitives/estilos';
import { type Pendencia, type TipoPendencia } from '@fiscoai/contracts';

import { type Prioridade } from './api';

export const PRIORIDADE: Record<Prioridade, { rotulo: string; tom: TomBadge }> = {
  ALTA: { rotulo: 'Alta', tom: 'perigo' },
  MEDIA: { rotulo: 'Média', tom: 'alerta' },
  BAIXA: { rotulo: 'Baixa', tom: 'neutro' },
};

export const TIPO_PENDENCIA: Record<TipoPendencia, string> = {
  CHAVE_SEM_XML: 'Chave sem XML',
  CANCELADA_JA_CLASSIFICADA: 'Cancelada já classificada',
  ITEM_SEM_CLASSIFICACAO: 'Item sem classificação',
  SEM_EMPRESA_DO_GRUPO: 'Sem empresa do grupo',
  SITUACAO_DESCONHECIDA: 'Situação desconhecida',
  EMPRESA_SEM_REGIME: 'Empresa sem regime',
  CONFERENCIA_ERRO: 'Conferência com erro',
  CFOP_SEM_REGRA: 'CFOP sem regra',
  NOTA_PROPRIA_OU_ENTRADA_DO_EMITENTE: 'Nota própria ou de entrada do emitente',
  ALERTA_CLASSIFICACAO: 'Alerta de classificação',
  CCE_RECEBIDA: 'CC-e recebida',
  CENTRO_CUSTO_AUSENTE: 'Sem centro de custo',
  CENTRO_CUSTO_INATIVO: 'Centro de custo inativo',
  ATIVO_SEM_CENTRO_CUSTO: 'Ativo sem centro de custo',
  CERTIFICADO_VENCENDO: 'Certificado A1 vencendo',
  CERTIFICADO_VENCIDO: 'Certificado A1 vencido',
  CIENCIA_SEM_CONCLUSAO: 'Ciência sem manifestação conclusiva',
  XML_FORA_DO_PRAZO_CIENCIA: 'XML pendente: ciência fora do prazo',
};

/** Tipos com destino fixo, que não dependem da nota nem da empresa. */
const DESTINO_FIXO: Partial<Record<TipoPendencia, string>> = {
  CHAVE_SEM_XML: '/chaves',
  XML_FORA_DO_PRAZO_CIENCIA: '/importacao',
};

/** Tipos resolvidos no cadastro da empresa, com a aba quando há uma. */
const NO_CADASTRO: Partial<Record<TipoPendencia, string>> = {
  CERTIFICADO_VENCENDO: '?aba=certificado',
  CERTIFICADO_VENCIDO: '?aba=certificado',
  SEM_EMPRESA_DO_GRUPO: '',
  EMPRESA_SEM_REGIME: '',
};

/**
 * Para onde a ação sugerida leva: a nota, a lista de chaves, o upload ou o cadastro da empresa.
 * Ciência sem conclusão vai à nota quando o XML já chegou; senão, à chave pendente.
 */
export function destinoDa(p: Pendencia): string {
  const fixo = DESTINO_FIXO[p.tipo];
  if (fixo) return fixo;
  const aba = NO_CADASTRO[p.tipo];
  if (aba !== undefined) return p.empresaId ? `/empresas/${p.empresaId}${aba}` : '/empresas';
  if (p.documentoId) return `/documentos?doc=${p.documentoId}`;
  return p.tipo === 'CIENCIA_SEM_CONCLUSAO' ? '/chaves' : '/documentos';
}
